<script setup>
  import { ref, onMounted } from 'vue'

  const fetchedSubs = ref()
  const numSubs = ref()

  const fetchSubs = async() => {
    const subs = [
      '/r/ListOfSubreddits',
      '/r/gifs',
      '/r/behindthegifs',
      '/r/gif',
      '/r/Cinemagraphs',
      '/r/WastedGifs',
      '/r/educationalgifs',
      '/r/perfectloops',
      '/r/highqualitygifs',
      '/r/gifsound',
      '/r/combinedgifs',
      '/r/retiredgif',
      '/r/michaelbaygifs',
      '/r/gifrecipes',
      '/r/mechanical_gifs',
      '/r/bettereveryloop',
      '/r/gifextra',
      '/r/slygifs',
      '/r/gifsthatkeepongiving',
      '/r/wholesomegifs',
      '/r/noisygifs',
      '/r/brokengifs',
      '/r/loadingicon',
      '/r/splitdepthgifs',
      '/r/blackpeoplegifs',
      '/r/whitepeoplegifs',
      '/r/asianpeoplegifs',
      '/r/scriptedasiangifs',
      '/r/reactiongifs',
      '/r/shittyreactiongifs',
      '/r/chemicalreactiongifs',
      '/r/physicsgifs',
      '/r/babyelephantgifs',
      '/r/weathergifs',
      '/r/pics',
      '/r/PhotoshopBattles',
      '/r/perfecttiming',
      '/r/itookapicture',
      '/r/Pareidolia',
      '/r/ExpectationVSReality',
      '/r/dogpictures',
      '/r/misleadingthumbnails',
      '/r/FifthWorldPics',
      '/r/TheWayWeWere',
      '/r/pic',
      '/r/nocontextpics',
      '/r/miniworlds',
      '/r/foundpaper',
      '/r/images',
      '/r/screenshots',
      '/r/mildlyinteresting',
      '/r/interestingasfuck',
      '/r/damnthatsinteresting',
      '/r/beamazed',
      '/r/reallifeshinies',
      '/r/thatsinsane',
      '/r/playitagainsam',
      '/r/gentlemanboners',
      '/r/prettygirls',
      '/r/hardbodies',
      '/r/girlsmirin',
      '/r/thinspo',
      '/r/goddesses',
      '/r/shorthairedhotties',
      '/r/fitandnatural',
      '/r/wrestlewiththeplot',
      '/r/skinnywithabs',
      '/r/bois',
      '/r/GentlemanBonersGifs',
      '/r/asiancuties',
      '/r/asiangirlsbeingcute',
      '/r/PhotoshopBattles',
      '/r/ColorizedHistory',
      '/r/reallifedoodles',
      '/r/HybridAnimals',
      '/r/colorization',
      '/r/amiugly',
      '/r/roastme',
      '/r/rateme',
      '/r/uglyduckling',
      '/r/prettygirlsuglyfaces',
      '/r/wallpapers',
      '/r/wallpaper',
      '/r/Offensive_Wallpapers',
      '/r/videos',
      '/r/youtubehaiku',
      '/r/artisanvideos',
      '/r/DeepIntoYouTube',
      '/r/nottimanderic',
      '/r/praisethecameraman',
      '/r/killthecameraman',
      '/r/perfectlycutscreams',
      '/r/donthelpjustfilm',
      '/r/abruptchaos',
      '/r/ShowerThoughts',
      '/r/DoesAnybodyElse',
      '/r/changemyview',
      '/r/crazyideas',
      '/r/howtonotgiveafuck',
      '/r/tipofmytongue',
      '/r/quotes',
      '/r/casualconversation',
      '/r/makenewfriendshere',
      '/r/relationship_advice',
      '/r/raisedbynarcissists',
      '/r/legaladvice',
      '/r/bestoflegaladvice',
      '/r/advice',
      '/r/amitheasshole',
      '/r/mechanicadvice',
      '/r/toastme',
      '/r/needadvice',
      '/r/IAmA',
      '/r/ExplainlikeIAmA',
      '/r/AMA',
      '/r/casualiama',
      '/r/de_Iama',
      '/r/whowouldwin',
      '/r/wouldyourather',
      '/r/scenesfromahat',
      '/r/AskOuija',
      '/r/themonkeyspaw',
      '/r/shittysuperpowers',
      '/r/godtiersuperpowers',
      '/r/decreasinglyverbose',
      '/r/jesuschristouija',
      '/r/whatisthisthing',
      '/r/AskReddit',
      '/r/answers',
      '/r/NoStupidQuestions',
      '/r/amiugly',
      '/r/whatsthisbug',
      '/r/samplesize',
      '/r/tooafraidtoask',
      '/r/whatsthisplant',
      '/r/isitbullshit',
      '/r/questions',
      '/r/morbidquestions',
      '/r/AskReddit',
      '/r/ShittyAskScience',
      '/r/TrueAskReddit',
      '/r/AskScienceFiction',
      '/r/AskOuija',
      '/r/AskScience',
      '/r/askhistorians',
      '/r/AskHistory',
      '/r/askculinary',
      '/r/AskSocialScience',
      '/r/askengineers',
      '/r/askphilosophy',
      '/r/askdocs',
      '/r/askwomen',
      '/r/askmen',
      '/r/askgaybros',
      '/r/askredditafterdark',
      '/r/asktransgender',
      '/r/askmenover30',
      '/r/tifu',
      '/r/self',
      '/r/confession',
      '/r/fatpeoplestories',
      '/r/confessions',
      '/r/storiesaboutkevin',
      '/r/talesfromtechsupport',
      '/r/talesfromretail',
      '/r/techsupportmacgyver',
      '/r/idontworkherelady',
      '/r/TalesFromYourServer',
      '/r/KitchenConfidential',
      '/r/TalesFromThePizzaGuy',
      '/r/TalesFromTheFrontDesk',
      '/r/talesfromthecustomer',
      '/r/talesfromcallcenters',
      '/r/talesfromthesquadcar',
      '/r/talesfromthepharmacy',
      '/r/starbucks',
      '/r/pettyrevenge',
      '/r/prorevenge',
      '/r/nuclearrevenge',
      '/r/nosleep',
      '/r/LetsNotMeet',
      '/r/Glitch_in_the_Matrix',
      '/r/shortscarystories',
      '/r/thetruthishere',
      '/r/UnresolvedMysteries',
      '/r/UnsolvedMysteries',
      '/r/depression',
      '/r/SuicideWatch',
      '/r/Anxiety',
      '/r/foreveralone',
      '/r/offmychest',
      '/r/socialanxiety',
      '/r/trueoffmychest',
      '/r/unsentletters',
      '/r/rant',
      '/r/YouShouldKnow',
      '/r/everymanshouldknow',
      '/r/LearnUselessTalents',
      '/r/changemyview',
      '/r/howto',
      '/r/Foodforthought',
      '/r/educationalgifs',
      '/r/lectures',
      '/r/education',
      '/r/college',
      '/r/GetStudying',
      '/r/teachers',
      '/r/watchandlearn',
      '/r/bulletjournal',
      '/r/applyingtocollege',
      '/r/lawschool',
      '/r/todayilearned',
      '/r/wikipedia',
      '/r/OutOfTheLoop',
      '/r/IWantToLearn',
      '/r/explainlikeimfive',
      '/r/explainlikeIAmA',
      '/r/ExplainLikeImCalvin',
      '/r/anthropology',
      '/r/Art',
      '/r/redditgetsdrawn',
      '/r/heavymind',
      '/r/drawing',
      '/r/graffiti',
      '/r/retrofuturism',
      '/r/sketchdaily',
      '/r/ArtPorn',
      '/r/pixelart',
      '/r/artfundamentals',
      '/r/learnart',
      '/r/specart',
      '/r/animation',
      '/r/wimmelbilder',
      '/r/illustration',
      '/r/streetart',
      '/r/place',
      '/r/breadstapledtotrees',
      '/r/chairsunderwater',
      '/r/painting',
      '/r/minipainting',
      '/r/gamedev',
      '/r/engineering',
      '/r/ubuntu',
      '/r/cscareerquestions',
      '/r/EngineeringStudents',
      '/r/askengineers',
      '/r/learnprogramming',
      '/r/compsci',
      '/r/java',
      '/r/javascript',
      '/r/coding',
      '/r/machinelearning',
      '/r/howtohack',
      '/r/cpp',
      '/r/artificial',
      '/r/python',
      '/r/learnpython',
      '/r/Economics',
      '/r/business',
      '/r/entrepreneur',
      '/r/marketing',
      '/r/BasicIncome',
      '/r/business',
      '/r/smallbusiness',
      '/r/stocks',
      '/r/wallstreetbets',
      '/r/stockmarket',
      '/r/environment',
      '/r/zerowaste',
      '/r/historynetwork',
      '/r/history',
      '/r/AskHistorians',
      '/r/AskHistory',
      '/r/ColorizedHistory',
      '/r/badhistory',
      '/r/100yearsago',
      '/r/HistoryPorn',
      '/r/PropagandaPosters',
      '/r/TheWayWeWere',
      '/r/historymemes',
      '/r/castles',
      '/r/linguistics',
      '/r/languagelearning',
      '/r/learnjapanese',
      '/r/french',
      '/r/etymology',
      '/r/law',
      '/r/math',
      '/r/theydidthemath',
      '/r/medicalschool',
      '/r/medizzy',
      '/r/psychology',
      '/r/JordanPeterson',
      '/r/Science',
      '/r/AskScience',
      '/r/cogsci',
      '/r/medicine',
      '/r/everythingscience',
      '/r/geology',
      '/r/Space',
      '/r/SpacePorn',
      '/r/astronomy',
      '/r/astrophotography',
      '/r/aliens',
      '/r/rockets',
      '/r/spacex',
      '/r/nasa',
      '/r/biology',
      '/r/Awwducational',
      '/r/chemicalreactiongifs',
      '/r/chemistry',
      '/r/physics',
      '/r/entertainment',
      '/r/fantheories',
      '/r/Disney',
      '/r/obscuremedia',
      '/r/anime',
      '/r/manga',
      '/r/anime_irl',
      '/r/awwnime',
      '/r/TsundereSharks',
      '/r/animesuggest',
      '/r/animemes',
      '/r/animegifs',
      '/r/animewallpaper',
      '/r/wholesomeanimemes',
      '/r/pokemon',
      '/r/onepiece',
      '/r/naruto',
      '/r/dbz',
      '/r/onepunchman',
      '/r/ShingekiNoKyojin',
      '/r/yugioh',
      '/r/BokuNoHeroAcademia',
      '/r/DDLC',
      '/r/berserk',
      '/r/hunterxhunter',
      '/r/tokyoghoul',
      '/r/shitpostcrusaders',
      '/r/Books',
      '/r/WritingPrompts',
      '/r/writing',
      '/r/literature',
      '/r/booksuggestions',
      '/r/lifeofnorman',
      '/r/poetry',
      '/r/screenwriting',
      '/r/freeEbooks',
      '/r/boottoobig',
      '/r/hfy',
      '/r/suggestmeabook',
      '/r/lovecraft',
      '/r/comics',
      '/r/comicbooks',
      '/r/polandball',
      '/r/marvel',
      '/r/webcomics',
      '/r/bertstrips',
      '/r/marvelstudios',
      '/r/defenders',
      '/r/marvelmemes',
      '/r/avengers',
      '/r/harrypotter',
      '/r/batman',
      '/r/calvinandhobbes',
      '/r/explainlikeimcalvin',
      '/r/xkcd',
      '/r/DCComics',
      '/r/arrow',
      '/r/unexpectedhogwarts',
      '/r/spiderman',
      '/r/deadpool',
      '/r/KingkillerChronicle',
      '/r/asoiaf',
      '/r/gameofthrones',
      '/r/freefolk',
      '/r/jonwinsthethrone',
      '/r/gameofthronesmemes',
      '/r/daeneryswinsthethrone',
      '/r/asongofmemesandrage',
      '/r/lotr',
      '/r/lotrmemes',
      '/r/tolkienfans',
      '/r/celebs',
      '/r/celebhub',
      '/r/EmmaWatson',
      '/r/jessicanigri',
      '/r/kateupton',
      '/r/alisonbrie',
      '/r/EmilyRatajkowski',
      '/r/jenniferlawrence',
      '/r/alexandradaddario',
      '/r/onetruegod',
      '/r/joerogan',
      '/r/keanubeingawesome',
      '/r/crewscrew',
      '/r/donaldglover',
      '/r/elonmusk',
      '/r/cosplay',
      '/r/cosplaygirls',
      '/r/lego',
      '/r/boardgames',
      '/r/rpg',
      '/r/chess',
      '/r/poker',
      '/r/jrpg',
      '/r/DnD',
      '/r/DnDGreentext',
      '/r/DnDBehindTheScreen',
      '/r/dndnext',
      '/r/dungeonsanddragons',
      '/r/criticalrole',
      '/r/DMAcademy',
      '/r/dndmemes',
      '/r/magicTCG',
      '/r/modernmagic',
      '/r/magicarena',
      '/r/zombies',
      '/r/cyberpunk',
      '/r/fantasy',
      '/r/scifi',
      '/r/starwars',
      '/r/startrek',
      '/r/asksciencefiction',
      '/r/prequelmemes',
      '/r/empiredidnothingwrong',
      '/r/SequelMemes',
      '/r/sciencefiction',
      '/r/InternetIsBeautiful',
      '/r/facepalm',
      '/r/wikipedia',
      '/r/creepyPMs',
      '/r/web_design',
      '/r/google',
      '/r/KenM',
      '/r/bannedfromclubpenguin',
      '/r/savedyouaclick',
      '/r/bestofworldstar',
      '/r/discordapp',
      '/r/snaplenses',
      '/r/tronix',
      '/r/instagramreality',
      '/r/internetstars',
      '/r/robinhood',
      '/r/shortcuts',
      '/r/scams',
      '/r/tiktokcringe',
      '/r/crackheadcraigslist',
      '/r/4chan',
      '/r/Classic4chan',
      '/r/greentext',
      '/r/facepalm',
      '/r/oldpeoplefacebook',
      '/r/facebookwins',
      '/r/indianpeoplefacebook',
      '/r/terriblefacebookmemes',
      '/r/insanepeoplefacebook',
      '/r/Tinder',
      '/r/OkCupid',
      '/r/KotakuInAction',
      '/r/wikileaks',
      '/r/shitcosmosays',
      '/r/twitch',
      '/r/livestreamfail',
      '/r/serialpodcast',
      '/r/podcasts',
      '/r/tumblrinaction',
      '/r/tumblr',
      '/r/blackpeopletwitter',
      '/r/scottishpeopletwitter',
      '/r/WhitePeopleTwitter',
      '/r/wholesomebpt',
      '/r/latinopeopletwitter',
      '/r/YoutubeHaiku',
      '/r/youtube',
      '/r/youngpeopleyoutube',
      '/r/gamegrumps',
      '/r/h3h3productions',
      '/r/CGPGrey',
      '/r/yogscast',
      '/r/jontron',
      '/r/Idubbbz',
      '/r/defranco',
      '/r/cynicalbrit',
      '/r/pyrocynical',
      '/r/SovietWomble',
      '/r/RedLetterMedia',
      '/r/videogamedunkey',
      '/r/loltyler1',
      '/r/ksi',
      '/r/MiniLadd',
      '/r/jacksepticeye',
      '/r/pewdiepiesubmissions',
      '/r/pewdiepie',
      '/r/roosterteeth',
      '/r/funhaus',
      '/r/rwby',
      '/r/cowchop',
      '/r/movies',
      '/r/documentaries',
      '/r/fullmoviesonyoutube',
      '/r/truefilm',
      '/r/bollywoodrealism',
      '/r/moviedetails',
      '/r/moviesinthemaking',
      '/r/fullmoviesonvimeo',
      '/r/continuityporn',
      '/r/ghibli',
      '/r/cinematography',
      '/r/shittymoviedetails',
      '/r/moviescirclejerk',
      '/r/starwars',
      '/r/harrypotter',
      '/r/lotr',
      '/r/lotrmemes',
      '/r/otmemes',
      '/r/marvelstudios',
      '/r/batman',
      '/r/DC_Cinematic',
      '/r/thanosdidnothingwrong',
      '/r/inthesoulstone',
      '/r/listentothis',
      '/r/music',
      '/r/listentothis',
      '/r/WeAreTheMusicMakers',
      '/r/mashups',
      '/r/vinyl',
      '/r/futurebeats',
      '/r/musictheory',
      '/r/guitarlessons',
      '/r/spotify',
      '/r/fakealbumcovers',
      '/r/ableton',
      '/r/kanye',
      '/r/radiohead',
      '/r/KendrickLamar',
      '/r/gorillaz',
      '/r/frankocean',
      '/r/donaldglover',
      '/r/eminem',
      '/r/brockhampton',
      '/r/beatles',
      '/r/deathgrips',
      '/r/pinkfloyd',
      '/r/classicalmusic',
      '/r/jazz',
      '/r/trap',
      '/r/indieheads',
      '/r/gamemusic',
      '/r/outrun',
      '/r/vaporwave',
      '/r/dubstep',
      '/r/electronicmusic',
      '/r/edmproduction',
      '/r/EDM',
      '/r/hiphopheads',
      '/r/hiphopimages',
      '/r/Metal',
      '/r/Metalcore',
      '/r/spop',
      '/r/kpop',
      '/r/funkopop',
      '/r/popheads',
      '/r/guitar',
      '/r/piano',
      '/r/bass',
      '/r/drums',
      '/r/sports',
      '/r/running',
      '/r/bicycling',
      '/r/golf',
      '/r/fishing',
      '/r/skiing',
      '/r/sportsarefun',
      '/r/tennis',
      '/r/rugbyunion',
      '/r/discgolf',
      '/r/cricket',
      '/r/sailing',
      '/r/nfl',
      '/r/CFB',
      '/r/fantasyfootball',
      '/r/nflstreams',
      '/r/patriots',
      '/r/eagles',
      '/r/greenbaypackers',
      '/r/minnesotavikings',
      '/r/losangelesrams',
      '/r/baseball',
      '/r/mlb',
      '/r/fantasybaseball',
      '/r/nba',
      '/r/collegebasketball',
      '/r/nbastreams',
      '/r/fantasybball',
      '/r/warriors',
      '/r/lakers',
      '/r/bostonceltics',
      '/r/torontoraptors',
      '/r/sixers',
      '/r/chicagobulls',
      '/r/skateboarding',
      '/r/snowboarding',
      '/r/longboarding',
      '/r/formula1',
      '/r/Nascar',
      '/r/MMA',
      '/r/squaredcircle',
      '/r/theocho',
      '/r/ufc',
      '/r/boxing',
      '/r/wwe',
      '/r/MMAStreams',
      '/r/hockey',
      '/r/nhl',
      '/r/nhlstreams',
      '/r/leafs',
      '/r/olympics',
      '/r/apocalympics2016',
      '/r/soccer',
      '/r/worldcup',
      '/r/Bundesliga',
      '/r/futbol',
      '/r/soccerstreams',
      '/r/MLS',
      '/r/fantasypl',
      '/r/gunners',
      '/r/reddevils',
      '/r/LiverpoolFC',
      '/r/chelseafc',
      '/r/Television',
      '/r/marvelstudios',
      '/r/japanesegameshows',
      '/r/shield',
      '/r/cordcutters',
      '/r/offlinetv',
      '/r/tvdetails',
      '/r/GameOfThrones',
      '/r/BreakingBad',
      '/r/thewalkingdead',
      '/r/community',
      '/r/arresteddevelopment',
      '/r/topgear',
      '/r/StarTrek',
      '/r/HIMYM',
      '/r/firefly',
      '/r/PandR',
      '/r/Sherlock',
      '/r/DunderMifflin',
      '/r/BetterCallSaul',
      '/r/TrueDetective',
      '/r/houseofcards',
      '/r/MakingaMurderer',
      '/r/FlashTV',
      '/r/trailerparkboys',
      '/r/mrrobot',
      '/r/siliconvalleyhbo',
      '/r/strangerthings',
      '/r/supernatural',
      '/r/thegrandtour',
      '/r/AmericanHorrorStory',
      '/r/rupaulsdragrace',
      '/r/westworld',
      '/r/blackmirror',
      '/r/FilthyFrank',
      '/r/orangeisthenewblack',
      '/r/twinpeaks',
      '/r/bigbrother',
      '/r/brooklynninenine',
      '/r/scrubs',
      '/r/howyoudoin',
      '/r/30rock',
      '/r/lifeisstrange',
      '/r/survivor',
      '/r/riverdale',
      '/r/letterkenny',
      '/r/Pokemon',
      '/r/AdventureTime',
      '/r/futurama',
      '/r/TheLastAirbender',
      '/r/ArcherFX',
      '/r/southpark',
      '/r/TheSimpsons',
      '/r/mylittlepony',
      '/r/rickandmorty',
      '/r/naruto',
      '/r/stevenuniverse',
      '/r/onepunchman',
      '/r/BobsBurgers',
      '/r/BoJackHorseman',
      '/r/gravityfalls',
      '/r/familyguy',
      '/r/kingofthehill',
      '/r/spongebob',
      '/r/dbz',
      '/r/DBZDokkanBattle',
      '/r/dragonballfighterz',
      '/r/doctorwho',
      '/r/gallifrey',
      '/r/IASIP',
      '/r/the_dennis',
      '/r/seinfeld',
      '/r/redditwritesseinfeld',
      '/r/seinfeldgifs',
      '/r/NetflixBestOf',
      '/r/Netflix',
      '/r/bestofnetflix',
      '/r/DIY',
      '/r/cosplay',
      '/r/woodworking',
      '/r/somethingimade',
      '/r/architecture',
      '/r/CoolGuides',
      '/r/WorldBuilding',
      '/r/ifyoulikeblank',
      '/r/DiWHY',
      '/r/knitting',
      '/r/sewing',
      '/r/modelmakers',
      '/r/crochet',
      '/r/ProtectAndServe',
      '/r/RTLSDR',
      '/r/digitalnomad',
      '/r/FastWorkers',
      '/r/accounting',
      '/r/preppers',
      '/r/redneckengineering',
      '/r/crossstitch',
      '/r/dumpsterdiving',
      '/r/gunpla',
      '/r/urbanplanning',
      '/r/cubers',
      '/r/blacksmith',
      '/r/toptalent',
      '/r/slavelabour',
      '/r/aquariums',
      '/r/plantedtank',
      '/r/art',
      '/r/Drawing',
      '/r/crafts',
      '/r/alternativeart',
      '/r/sketchdaily',
      '/r/artporn',
      '/r/glitch_art',
      '/r/coloringcorruptions',
      '/r/restofthefuckingowl',
      '/r/DisneyVacation',
      '/r/illustration',
      '/r/Writing',
      '/r/writingprompts',
      '/r/screenwriting',
      '/r/fountainpens',
      '/r/calligraphy',
      '/r/handwriting',
      '/r/twosentencehorror',
      '/r/brandnewsentence',
      '/r/cars',
      '/r/motorcycles',
      '/r/carporn',
      '/r/justrolledintotheshop',
      '/r/idiotsincars',
      '/r/Shitty_Car_Mods',
      '/r/autos',
      '/r/roadcam',
      '/r/AutoDetailing',
      '/r/awesomecarmods',
      '/r/projectcar',
      '/r/cartalk',
      '/r/tiresaretheenemy',
      '/r/roadtrip',
      '/r/convenientcop',
      '/r/dashcamgifs',
      '/r/subaru',
      '/r/teslamotors',
      '/r/bmw',
      '/r/jeep',
      '/r/CrappyDesign',
      '/r/web_design',
      '/r/graphic_design',
      '/r/design',
      '/r/designporn',
      '/r/InteriorDesign',
      '/r/ATBGE',
      '/r/dontdeadopeninside',
      '/r/assholedesign',
      '/r/keming',
      '/r/logodesign',
      '/r/tombstoning',
      '/r/dangerousdesign',
      '/r/actlikeyoubelong',
      '/r/irlsmurfing',
      '/r/MilitaryPorn',
      '/r/military',
      '/r/combatfootage',
      '/r/militarygfys',
      '/r/army',
      '/r/warshipporn',
      '/r/justbootthings',
      '/r/guns',
      '/r/gunporn',
      '/r/gundeals',
      '/r/ar15',
      '/r/firearms',
      '/r/ccw',
      '/r/airsoft',
      '/r/Jobs',
      '/r/forhire',
      '/r/cscareerquestions',
      '/r/workonline',
      '/r/guitar',
      '/r/WeAreTheMusicMakers',
      '/r/edmproduction',
      '/r/piano',
      '/r/ableton',
      '/r/drums',
      '/r/FL_Studio',
      '/r/urbanexploration',
      '/r/survival',
      '/r/backpacking',
      '/r/camping',
      '/r/homestead',
      '/r/MTB',
      '/r/outdoors',
      '/r/wildernessbackpacking',
      '/r/campinggear',
      '/r/bushcraft',
      '/r/gardening',
      '/r/indoorgarden',
      '/r/campingandhiking',
      '/r/hiking',
      '/r/ultralight',
      '/r/photography',
      '/r/itookapicture',
      '/r/Filmmakers',
      '/r/astrophotography',
      '/r/analog',
      '/r/photocritique',
      '/r/postprocessing',
      '/r/aviation',
      '/r/flying',
      '/r/sysadmin',
      '/r/engineering',
      '/r/compsci',
      '/r/webdev',
      '/r/programmerhumor',
      '/r/graphic_design',
      '/r/mechanicalkeyboards',
      '/r/reverseengineering',
      '/r/itsaunixsystem',
      '/r/plex',
      '/r/multicopter',
      '/r/programminghorror',
      '/r/dailyprogrammer',
      '/r/coding',
      '/r/python',
      '/r/java',
      '/r/cpp',
      '/r/security',
      '/r/buildapc',
      '/r/buildapcsales',
      '/r/buildapcforme',
      '/r/talesfromtechsupport',
      '/r/techsupportgore',
      '/r/techsupport',
      '/r/softwaregore',
      '/r/iiiiiiitttttttttttt',
      '/r/watches',
      '/r/lockpicking',
      '/r/knives',
      '/r/specializedtools',
      '/r/knifeclub',
      '/r/travel',
      '/r/solotravel',
      '/r/japantravel',
      '/r/shoestring',
      '/r/LifeProTips',
      '/r/lifehacks',
      '/r/geek',
      '/r/EDC',
      '/r/simpleliving',
      '/r/tinyhouses',
      '/r/rainmeter',
      '/r/vandwellers',
      '/r/UnethicalLifeProTips',
      '/r/vagabond',
      '/r/illegallifeprotips',
      '/r/malelifestyle',
      '/r/malelivingspace',
      '/r/TheGirlSurvivalGuide',
      '/r/homeimprovement',
      '/r/homelab',
      '/r/homeautomation',
      '/r/battlestations',
      '/r/hometheater',
      '/r/teenagers',
      '/r/introvert',
      '/r/ADHD',
      '/r/totallynotrobots',
      '/r/polyamory',
      '/r/teachers',
      '/r/aliensamongus',
      '/r/neverbrokeabone',
      '/r/bipolar',
      '/r/beards',
      '/r/vegan',
      '/r/swoleacceptance',
      '/r/tall',
      '/r/lgbt',
      '/r/gaybros',
      '/r/actuallesbians',
      '/r/gaymers',
      '/r/bisexual',
      '/r/askgaybros',
      '/r/ainbow',
      '/r/gay',
      '/r/gay_irl',
      '/r/asktransgender',
      '/r/transgender',
      '/r/parenting',
      '/r/daddit',
      '/r/babybumps',
      '/r/drunk',
      '/r/scotch',
      '/r/stopdrinking',
      '/r/cocktails',
      '/r/wine',
      '/r/bourbon',
      '/r/whiskey',
      '/r/beer',
      '/r/homebrewing',
      '/r/showerbeer',
      '/r/beerporn',
      '/r/trees',
      '/r/marijuana',
      '/r/microgrowery',
      '/r/eldertrees',
      '/r/see',
      '/r/leaves',
      '/r/weed',
      '/r/weedstocks',
      '/r/cannabis',
      '/r/drugs',
      '/r/electronic_cigarette',
      '/r/stonerengineering',
      '/r/Nootropics',
      '/r/LSD',
      '/r/vaporents',
      '/r/Vaping',
      '/r/stopsmoking',
      '/r/shrooms',
      '/r/dmt',
      '/r/GetMotivated',
      '/r/health',
      '/r/ZenHabits',
      '/r/motivation',
      '/r/LucidDreaming',
      '/r/meditation',
      '/r/Psychonaut',
      '/r/mentalhealth',
      '/r/Fitness',
      '/r/Fitness',
      '/r/xxfitness',
      '/r/fitmeals',
      '/r/paleo',
      '/r/nutrition',
      '/r/vegetarian',
      '/r/leangains',
      '/r/HealthyFood',
      '/r/intermittentfasting',
      '/r/fasting',
      '/r/keto',
      '/r/ketorecipes',
      '/r/ketogains',
      '/r/bicycling',
      '/r/yoga',
      '/r/skateboarding',
      '/r/climbing',
      '/r/backpacking',
      '/r/bjj',
      '/r/skiing',
      '/r/crossfit',
      '/r/bodybuilding',
      '/r/WeightRoom',
      '/r/powerlifting',
      '/r/running',
      '/r/c25k',
      '/r/Medicine',
      '/r/Coronavirus',
      '/r/COVID19',
      '/r/loseit',
      '/r/bodyweightfitness',
      '/r/gainit',
      '/r/swoleacceptance',
      '/r/flexibility',
      '/r/progresspics',
      '/r/brogress',
      '/r/makeupaddiction',
      '/r/SkincareAddiction',
      '/r/beards',
      '/r/wicked_edge',
      '/r/RedditLaqueristas',
      '/r/AsianBeauty',
      '/r/piercing',
      '/r/FancyFollicles',
      '/r/malehairadvice',
      '/r/curlyhair',
      '/r/tattoos',
      '/r/badtattoos',
      '/r/tattoo',
      '/r/malefashionadvice',
      '/r/frugalmalefashion',
      '/r/femalefashionadvice',
      '/r/thriftstorehauls',
      '/r/fashion',
      '/r/streetwear',
      '/r/malefashion',
      '/r/supremeclothing',
      '/r/FashionReps',
      '/r/designerreps',
      '/r/sneakers',
      '/r/repsneakers',
      '/r/goodyearwelt',
      '/r/food',
      '/r/FoodPorn',
      '/r/foodhacks',
      '/r/shittyfoodporn',
      '/r/eatsandwiches',
      '/r/nutrition',
      '/r/mealtimevideos',
      '/r/WeWantPlates',
      '/r/forbiddensnacks',
      '/r/seriouseats',
      '/r/spicy',
      '/r/cooking',
      '/r/slowcooking',
      '/r/askculinary',
      '/r/baking',
      '/r/mealprepsunday',
      '/r/breadit',
      '/r/cookingforbeginners',
      '/r/smoking',
      '/r/castiron',
      '/r/instantpot',
      '/r/sousvide',
      '/r/EatCheapAndHealthy',
      '/r/fitmeals',
      '/r/budgetfood',
      '/r/ketorecipes',
      '/r/vegan',
      '/r/1200isplenty',
      '/r/Cheap_Meals',
      '/r/HealthyFood',
      '/r/veganrecipes',
      '/r/intermittentfasting',
      '/r/fasting',
      '/r/coffee',
      '/r/tea',
      '/r/recipes',
      '/r/gifrecipes',
      '/r/veganrecipes',
      '/r/pizza',
      '/r/grilledcheese',
      '/r/ramen',
      '/r/bbq',
      '/r/sushi',
      '/r/PersonalFinance',
      '/r/Entrepreneur',
      '/r/beermoney',
      '/r/startups',
      '/r/finance',
      '/r/economy',
      '/r/financialindependence',
      '/r/apphookup',
      '/r/churning',
      '/r/realestate',
      '/r/flipping',
      '/r/antimlm',
      '/r/ripple',
      '/r/Iota',
      '/r/stellar',
      '/r/personalfinancecanada',
      '/r/investing',
      '/r/wallstreetbets',
      '/r/millionairemakers',
      '/r/weedstocks',
      '/r/options',
      '/r/pennystocks',
      '/r/frugal',
      '/r/EatCheapAndHealthy',
      '/r/frugalmalefashion',
      '/r/budgetfood',
      '/r/cheap_meals',
      '/r/Frugal_Jerk',
      '/r/povertyfinance',
      '/r/shutupandtakemymoney',
      '/r/BuyItForLife',
      '/r/crappyoffbrands',
      '/r/shouldibuythisgame',
      '/r/Anticonsumption',
      '/r/sbubby',
      '/r/Wellworn',
      '/r/ineeeedit',
      '/r/didntknowiwantedthat',
      '/r/Bitcoin',
      '/r/dogecoin',
      '/r/CryptoCurrency',
      '/r/ethereum',
      '/r/ethtrade',
      '/r/litecoin',
      '/r/btc',
      '/r/garlicoin',
      '/r/cardano',
      '/r/Vechain',
      '/r/Psychonaut',
      '/r/Buddhism',
      '/r/Stoicism',
      '/r/occult',
      '/r/atheism',
      '/r/trueatheism',
      '/r/Christianity',
      '/r/dankchristianmemes',
      '/r/exmormon',
      '/r/Catholicism',
      '/r/philosophy',
      '/r/askphilosophy',
      '/r/socialskills',
      '/r/socialengineering',
      '/r/weddingplanning',
      '/r/Parenting',
      '/r/childfree',
      '/r/raisedbynarcissists',
      '/r/incest',
      '/r/daddit',
      '/r/justnomil',
      '/r/justnofamily',
      '/r/relationships',
      '/r/relationship_advice',
      '/r/dating_advice',
      '/r/breakups',
      '/r/dating',
      '/r/Tinder',
      '/r/OKCupid',
      '/r/r4r',
      '/r/dirtyr4r',
      '/r/longdistance',
      '/r/sex',
      '/r/seduction',
      '/r/nofap',
      '/r/deadbedrooms',
      '/r/polyamory',
      '/r/GetMotivated',
      '/r/QuotesPorn',
      '/r/getdisciplined',
      '/r/happy',
      '/r/productivity',
      '/r/DecidingToBeBetter',
      '/r/mademesmile',
      '/r/selfimprovement',
      '/r/iwantout',
      '/r/humansbeingbros',
      '/r/happycrowds',
      '/r/sportsarefun',
      '/r/GetStudying',
      '/r/motivation',
      '/r/gatesopencomeonin',
      '/r/technology',
      '/r/technology',
      '/r/internetisbeautiful',
      '/r/futurology',
      '/r/pcmasterrace',
      '/r/buildapc',
      '/r/talesfromtechsupport',
      '/r/netsec',
      '/r/gamedev',
      '/r/design',
      '/r/engineering',
      '/r/jailbreak',
      '/r/compsci',
      '/r/tech',
      '/r/hacking',
      '/r/imaginarytechnology',
      '/r/privacy',
      '/r/torrents',
      '/r/networking',
      '/r/infographics',
      '/r/piracy',
      '/r/EngineeringPorn',
      '/r/cableporn',
      '/r/simulated',
      '/r/onions',
      '/r/unixporn',
      '/r/crackwatch',
      '/r/php',
      '/r/aboringdystopia',
      '/r/virtualreality',
      '/r/opensource',
      '/r/3Dprinting',
      '/r/functionalprint',
      '/r/nintendo',
      '/r/spacex',
      '/r/nasa',
      '/r/amd',
      '/r/nvidia',
      '/r/photoshop',
      '/r/firefox',
      '/r/Android',
      '/r/AndroidApps',
      '/r/AndroidGaming',
      '/r/AndroidDev',
      '/r/AndroidThemes',
      '/r/oneplus',
      '/r/apple',
      '/r/iphone',
      '/r/mac',
      '/r/ipad',
      '/r/applewatch',
      '/r/gadgets',
      '/r/raspberry_pi',
      '/r/electronics',
      '/r/arduino',
      '/r/trackers',
      '/r/gopro',
      '/r/blender',
      '/r/amazonecho',
      '/r/RetroPie',
      '/r/hardware',
      '/r/hardwareswap',
      '/r/Addons4Kodi',
      '/r/kodi',
      '/r/google',
      '/r/chromecast',
      '/r/googlepixel',
      '/r/googlehome',
      '/r/linux',
      '/r/linux_gaming',
      '/r/linux4noobs',
      '/r/linuxmasterrace',
      '/r/archlinux',
      '/r/Windows10',
      '/r/windows',
      '/r/excel',
      '/r/surface',
      '/r/microsoft',
      '/r/dataisbeautiful',
      '/r/DataHoarder',
      '/r/datascience',
      '/r/Bitcoin',
      '/r/dogecoin',
      '/r/CryptoCurrency',
      '/r/ethereum',
      '/r/ethtrader',
      '/r/btc',
      '/r/litecoin',
      '/r/bitcoinmarkets',
      '/r/cryptomarkets',
      '/r/monero',
      '/r/neo',
      '/r/programming',
      '/r/learnprogramming',
      '/r/python',
      '/r/java',
      '/r/javascript',
      '/r/learnpython',
      '/r/excel',
      '/r/unity3d',
      '/r/reactjs',
      '/r/audiophile',
      '/r/headphones',
      '/r/audioengineering',
      '/r/funny',
      '/r/humor',
      '/r/contagiouslaughter',
      '/r/standupcomedy',
      '/r/ProgrammerHumor',
      '/r/prematurecelebration',
      '/r/ChildrenFallingOver',
      '/r/dadreflexes',
      '/r/kenm',
      '/r/politicalhumor',
      '/r/accidentalcomedy',
      '/r/funnyandsad',
      '/r/kidsarefuckingstupid',
      '/r/notkenm',
      '/r/suspiciouslyspecific',
      '/r/oddlyspecific',
      '/r/rimjob_steve',
      '/r/dark_humor',
      '/r/stepdadreflexes',
      '/r/congratslikeimfive',
      '/r/darkhumorandmemes',
      '/r/ComedyCemetery',
      '/r/comedyheaven',
      '/r/comedynecromancy',
      '/r/comedyhomicide',
      '/r/comedynecrophilia',
      '/r/Jokes',
      '/r/dadjokes',
      '/r/standupshots',
      '/r/punny',
      '/r/antijokes',
      '/r/meanjokes',
      '/r/3amjokes',
      '/r/puns',
      '/r/WordAvalanches',
      '/r/darkjokes',
      '/r/AnimalReddits',
      '/r/AnimalsBeingJerks',
      '/r/AnimalsBeingBros',
      '/r/AnimalPorn',
      '/r/AnimalsBeingDerps',
      '/r/likeus',
      '/r/stoppedworking',
      '/r/hitmanimals',
      '/r/animaltextgifs',
      '/r/BeforeNAfterAdoption',
      '/r/sneks',
      '/r/TsundereSharks',
      '/r/whatsthisbug',
      '/r/HybridAnimals',
      '/r/zoomies',
      '/r/brushybrushy',
      '/r/bigboye',
      '/r/curledfeetsies',
      '/r/mlem',
      '/r/Floof',
      '/r/shittyanimalfacts',
      '/r/animalsthatlovemagic',
      '/r/spiderbro',
      '/r/properanimalnames',
      '/r/reverseanimalrescue',
      '/r/animalsdoingstuff',
      '/r/sploot',
      '/r/birdswitharms',
      '/r/superbowl',
      '/r/birbs',
      '/r/partyparrot',
      '/r/birdsbeingdicks',
      '/r/emuwarflashbacks',
      '/r/birdsarentreal',
      '/r/babyelephantgifs',
      '/r/sloths',
      '/r/foxes',
      '/r/trashpandas',
      '/r/happycowgifs',
      '/r/rabbits',
      '/r/goatparkour',
      '/r/bearsdoinghumanthings',
      '/r/cats',
      '/r/CatSubs',
      '/r/startledcats',
      '/r/catpictures',
      '/r/catsstandingup',
      '/r/catpranks',
      '/r/meow_irl',
      '/r/holdmycatnip',
      '/r/catslaps',
      '/r/thecatdimension',
      '/r/babybigcatgifs',
      '/r/catloaf',
      '/r/thisismylifemeow',
      '/r/cattaps',
      '/r/teefies',
      '/r/tuckedinkitties',
      '/r/catsareassholes',
      '/r/catsisuottatfo',
      '/r/stuffoncats',
      '/r/bigcatgifs',
      '/r/jellybeantoes',
      '/r/catsareliquid',
      '/r/catgifs',
      '/r/blackcats',
      '/r/supermodelcats',
      '/r/chonkers',
      '/r/tightpussy',
      '/r/catswithjobs',
      '/r/catswhoyell',
      '/r/whatswrongwithyourcat',
      '/r/illegallysmolcats',
      '/r/dogs',
      '/r/dogpictures',
      '/r/dogtraining',
      '/r/woof_irl',
      '/r/WhatsWrongWithYourDog',
      '/r/dogberg',
      '/r/dogswithjobs',
      '/r/masterreturns',
      '/r/barkour',
      '/r/blop',
      '/r/puppysmiles',
      '/r/puppies',
      '/r/petthedamndog',
      '/r/corgi',
      '/r/Pitbulls',
      '/r/goldenretrievers',
      '/r/incorgnito',
      '/r/babycorgis',
      '/r/conspiracy',
      '/r/skeptic',
      '/r/karmaconspiracy',
      '/r/UFOs',
      '/r/conspiratard',
      '/r/empiredidnothingwrong',
      '/r/scp',
      '/r/birdsarentreal',
      '/r/conspiracytheories',
      '/r/cringepics',
      '/r/cringe',
      '/r/instant_regret',
      '/r/blunderyears',
      '/r/facepalm',
      '/r/fatlogic',
      '/r/publicfreakout',
      '/r/actualpublicfreakouts',
      '/r/lewronggeneration',
      '/r/fellowkids',
      '/r/sadcringe',
      '/r/corporatefacepalm',
      '/r/4PanelCringe',
      '/r/amibeingdetained',
      '/r/instantbarbarians',
      '/r/watchpeopledieinside',
      '/r/technicallythetruth',
      '/r/accidentalracism',
      '/r/engrish',
      '/r/wokekids',
      '/r/masterhacker',
      '/r/cringetopia',
      '/r/holup',
      '/r/agedlikemilk',
      '/r/tiktokcringe',
      '/r/facepalm',
      '/r/quityourbullshit',
      '/r/thathappened',
      '/r/delusionalartists',
      '/r/oopsdidntmeanto',
      '/r/beholdthemasterrace',
      '/r/murderedbywords',
      '/r/ihavesex',
      '/r/woooosh',
      '/r/badfaketexts',
      '/r/boneappletea',
      '/r/atetheonion',
      '/r/iamatotalpieceofshit',
      '/r/suicidebywords',
      '/r/kamikazebywords',
      '/r/wowthanksimcured',
      '/r/topmindsofreddit',
      '/r/lostredditors',
      '/r/dontyouknowwhoiam',
      '/r/NobodyAsked',
      '/r/dontfundme',
      '/r/nothingeverhappens',
      '/r/vaxxhappened',
      '/r/goodfaketexts',
      '/r/delusionalcraigslist',
      '/r/suspiciousquotes',
      '/r/facingtheirparenting',
      '/r/ihadastroke',
      '/r/untrustworthypoptarts',
      '/r/phonesarebad',
      '/r/rareinsults',
      '/r/clevercomebacks',
      '/r/fuckyoukaren',
      '/r/uselessredcircle',
      '/r/leopardsatemyface',
      '/r/confidentlyincorrect',
      '/r/niceguys',
      '/r/mallninjashit',
      '/r/ChoosingBeggars',
      '/r/gatekeeping',
      '/r/creepyasterisks',
      '/r/inceltears',
      '/r/humblebrag',
      '/r/nothowdrugswork',
      '/r/whiteknighting',
      '/r/neckbeardrpg',
      '/r/virginsvschad',
      '/r/nicegirls',
      '/r/notliketheothergirls',
      '/r/notlikeothergirls',
      '/r/entitledbitch',
      '/r/iamverysmart',
      '/r/iamverybadass',
      '/r/iamveryrandom',
      '/r/imveryedgy',
      '/r/justneckbeardthings',
      '/r/neckbeardnests',
      '/r/entitledparents',
      '/r/insaneparents',
      '/r/shitmomgroupssay',
      '/r/aww',
      '/r/cats',
      '/r/animalsbeingjerks',
      '/r/animalsbeingbros',
      '/r/Awwducational',
      '/r/dogs',
      '/r/corgi',
      '/r/thisismylifenow',
      '/r/blep',
      '/r/eyebeach',
      '/r/tippytaps',
      '/r/awww',
      '/r/babycorgis',
      '/r/WTF',
      '/r/DeepIntoYouTube',
      '/r/fifthworldproblems',
      '/r/awwwtf',
      '/r/wellthatsucks',
      '/r/streetfights',
      '/r/yesyesyesyesno',
      '/r/wtfstockphotos',
      '/r/yesyesyesno',
      '/r/maybemaybemaybe',
      '/r/oddlyterrifying',
      '/r/thatlookedexpensive',
      '/r/wtfgaragesale',
      '/r/Whatthefuckgetitoffme',
      '/r/imsorryjon',
      '/r/mildlyinfuriating',
      '/r/crappydesign',
      '/r/rage',
      '/r/Bad_Cop_No_Donut',
      '/r/gifsthatendtoosoon',
      '/r/peoplebeingjerks',
      '/r/casualchildabuse',
      '/r/fuckthesepeople',
      '/r/makemesuffer',
      '/r/cursedimages',
      '/r/cursedcomments',
      '/r/tihi',
      '/r/blursedimages',
      '/r/cursed_images',
      '/r/blessedimages',
      '/r/imgoingtohellforthis',
      '/r/toosoon',
      '/r/trashy',
      '/r/awfuleyebrows',
      '/r/awfuleverything',
      '/r/13or30',
      '/r/ghettoglamourshots',
      '/r/peopleofwalmart',
      '/r/hittablefaces',
      '/r/punchablefaces',
      '/r/botchedsurgeries',
      '/r/subwaycreatures',
      '/r/nosleep',
      '/r/morbidreality',
      '/r/whatcouldgowrong',
      '/r/Glitch_in_the_Matrix',
      '/r/Paranormal',
      '/r/nononono',
      '/r/horror',
      '/r/shortscarystories',
      '/r/lastimages',
      '/r/peoplefuckingdying',
      '/r/serialkillers',
      '/r/WhyWereTheyFilming',
      '/r/WinStupidPrizes',
      '/r/scarysigns',
      '/r/ghosts',
      '/r/crimescene',
      '/r/creepy',
      '/r/creepypasta',
      '/r/creepysigns',
      '/r/megalophobia',
      '/r/creepyencounters',
      '/r/ImaginaryMonsters',
      '/r/ImaginaryLeviathans',
      '/r/ImaginaryMindscapes',
      '/r/imaginarycharacters',
      '/r/imaginarylandscapes',
      '/r/imaginarymaps',
      '/r/SympatheticMonsters',
      '/r/imaginarywesteros',
      '/r/imaginarysliceoflife',
      '/r/thalassophobia',
      '/r/TheDepthsBelow',
      '/r/submechanophobia',
      '/r/freebies',
      '/r/fullmoviesonyoutube',
      '/r/efreebies',
      '/r/randomactsofgaming',
      '/r/freeEbooks',
      '/r/fullmoviesonvimeo',
      '/r/freegamesonsteam',
      '/r/googleplaydeals',
      '/r/megalinks',
      '/r/opendirectories',
      '/r/Random_Acts_Of_Pizza',
      '/r/coupons',
      '/r/dealsreddit',
      '/r/freegamefindings',
      '/r/deals',
      '/r/assistance',
      '/r/free',
      '/r/MaleFashionAdvice',
      '/r/everymanshouldknow',
      '/r/askmen',
      '/r/frugalmalefashion',
      '/r/MensRights',
      '/r/malelifestyle',
      '/r/trollychromosome',
      '/r/malelivingspace',
      '/r/malehairadvice',
      '/r/malefashion',
      '/r/bigdickproblems',
      '/r/askmenover30',
      '/r/TwoXChromosomes',
      '/r/askwomen',
      '/r/LadyBoners',
      '/r/TrollXChromosomes',
      '/r/femalefashionadvice',
      '/r/xxfitness',
      '/r/TheGirlSurvivalGuide',
      '/r/abrathatfits',
      '/r/badwomensanatomy',
      '/r/nothowgirlswork',
      '/r/menwritingwomen',
      '/r/LocationReddits',
      '/r/MapPorn',
      '/r/polandball',
      '/r/vexillology',
      '/r/SouthAfrica',
      '/r/europe',
      '/r/ireland',
      '/r/thenetherlands',
      '/r/denmark',
      '/r/italy',
      '/r/norge',
      '/r/polska',
      '/r/suomi',
      '/r/romania',
      '/r/belgium',
      '/r/scotland',
      '/r/austria',
      '/r/france',
      '/r/french',
      '/r/de',
      '/r/germany',
      '/r/german',
      '/r/ANormalDayInRussia',
      '/r/youseecomrade',
      '/r/gtaorrussia',
      '/r/sweden',
      '/r/SWARJE',
      '/r/swedishproblems',
      '/r/intresseklubben',
      '/r/svenskpolitik',
      '/r/spop',
      '/r/Allsvenskan',
      '/r/unitedkingdom',
      '/r/britishproblems',
      '/r/london',
      '/r/ukpolitics',
      '/r/casualuk',
      '/r/canada',
      '/r/toronto',
      '/r/vancouver',
      '/r/canadapolitics',
      '/r/calgary',
      '/r/personalfinancecanada',
      '/r/mexico',
      '/r/MURICA',
      '/r/nyc',
      '/r/chicago',
      '/r/portland',
      '/r/boston',
      '/r/atlanta',
      '/r/washingtondc',
      '/r/philadelphia',
      '/r/newjersey',
      '/r/minnesota',
      '/r/michigan',
      '/r/losangeles',
      '/r/sanfrancisco',
      '/r/bayarea',
      '/r/california',
      '/r/sandiego',
      '/r/disneyland',
      '/r/denver',
      '/r/colorado',
      '/r/floridaman',
      '/r/waltdisneyworld',
      '/r/austin',
      '/r/houston',
      '/r/texas',
      '/r/dallas',
      '/r/seattle',
      '/r/SeattleWA',
      '/r/australia',
      '/r/newzealand',
      '/r/melbourne',
      '/r/sydney',
      '/r/Philippines',
      '/r/india',
      '/r/singapore',
      '/r/china',
      '/r/hongkong',
      '/r/japan',
      '/r/japanpics',
      '/r/japantravel',
      '/r/kpop',
      '/r/pyongyang',
      '/r/korea',
      '/r/brasil',
      '/r/argentina',
      '/r/ithadtobebrazil',
      '/r/OutOfTheLoop',
      '/r/nocontext',
      '/r/tldr',
      '/r/Enhancement',
      '/r/SecretSanta',
      '/r/MuseumOfReddit',
      '/r/theoryofreddit',
      '/r/threadkillers',
      '/r/evenwithcontext',
      '/r/beetlejuicing',
      '/r/redditinreddit',
      '/r/announcements',
      '/r/blog',
      '/r/beta',
      '/r/help',
      '/r/place',
      '/r/sequence',
      '/r/thebutton',
      '/r/circleoftrust',
      '/r/baconreader',
      '/r/alienblue',
      '/r/baconit',
      '/r/redditsync',
      '/r/relayforreddit',
      '/r/apolloapp',
      '/r/redditmobile',
      '/r/Circlejerk',
      '/r/DiWHY',
      '/r/frugal_jerk',
      '/r/moviescirclejerk',
      '/r/SubredditDrama',
      '/r/drama',
      '/r/hobbydrama',
      '/r/rbi',
      '/r/ShitRedditSays',
      '/r/karmaconspiracy',
      '/r/undelete',
      '/r/jesuschristreddit',
      '/r/karmacourt',
      '/r/titlegore',
      '/r/ShitAmericansSay',
      '/r/againsthatesubreddits',
      '/r/bestof',
      '/r/DepthHub',
      '/r/BestOfReports',
      '/r/bestoflegaladvice',
      '/r/punpatrol',
      '/r/redditsings',
      '/r/subredditoftheday',
      '/r/wowthissubexists',
      '/r/newreddits',
      '/r/ofcoursethatsathing',
      '/r/findareddit',
      '/r/modnews',
      '/r/redditrequest',
      '/r/subredditsimulator',
      '/r/subredditsimmeta',
      '/r/TrueReddit',
      '/r/awesome',
      '/r/TipOfMyTongue',
      '/r/TipOfMyPenis',
      '/r/woahdude',
      '/r/frisson',
      '/r/asmr',
      '/r/VaporwaveAesthetics',
      '/r/glitchinthematrix',
      '/r/earthporn',
      '/r/hardcoreaww',
      '/r/hitmanimals',
      '/r/natureisfuckinglit',
      '/r/heavyseas',
      '/r/marijuanaenthusiasts',
      '/r/succulents',
      '/r/mycology',
      '/r/bonsai',
      '/r/TreesSuckingOnThings',
      '/r/houseplants',
      '/r/natureismetal',
      '/r/Natureisbrutal',
      '/r/naturewasmetal',
      '/r/weathergifs',
      '/r/tropicalweather',
      '/r/worldnews',
      '/r/news',
      '/r/nottheonion',
      '/r/UpliftingNews',
      '/r/offbeat',
      '/r/gamernews',
      '/r/floridaman',
      '/r/energy',
      '/r/syriancivilwar',
      '/r/truecrime',
      '/r/TheOnion',
      '/r/AteTheOnion',
      '/r/OldSchoolCool',
      '/r/TheWayWeWere',
      '/r/nostalgia',
      '/r/vinyl',
      '/r/forwardsfromgrandma',
      '/r/oldphotosinreallife',
      '/r/firstworldanarchists',
      '/r/wheredidthesodago',
      '/r/unexpectedthuglife',
      '/r/youdontsurf',
      '/r/montageparodies',
      '/r/outside',
      '/r/OSHA',
      '/r/hailcorporate',
      '/r/im14andthisisdeep',
      '/r/bollywoodrealism',
      '/r/AccidentalRenaissance',
      '/r/maliciouscompliance',
      '/r/fakehistoryporn',
      '/r/coaxedintoasnafu',
      '/r/irleastereggs',
      '/r/sfwpornnetwork',
      '/r/EarthPorn',
      '/r/HistoryPorn',
      '/r/FoodPorn',
      '/r/JusticePorn',
      '/r/AbandonedPorn',
      '/r/SpacePorn',
      '/r/RoomPorn',
      '/r/QuotesPorn',
      '/r/MapPorn',
      '/r/CityPorn',
      '/r/carporn',
      '/r/humanporn',
      '/r/penmanshipporn',
      '/r/militaryporn',
      '/r/DesignPorn',
      '/r/ThingsCutInHalfPorn',
      '/r/ArchitecturePorn',
      '/r/ExposurePorn',
      '/r/futureporn',
      '/r/adrenalineporn',
      '/r/waterporn',
      '/r/machineporn',
      '/r/animalporn',
      '/r/movieposterporn',
      '/r/illusionporn',
      '/r/destructionporn',
      '/r/adporn',
      '/r/artefactporn',
      '/r/gunporn',
      '/r/skyporn',
      '/r/powerwashingporn',
      '/r/ArtPorn',
      '/r/InfrastructurePorn',
      '/r/VillagePorn',
      '/r/shockwaveporn',
      '/r/productporn',
      '/r/macroporn',
      '/r/cabinporn',
      '/r/houseporn',
      '/r/mineralporn',
      '/r/microporn',
      '/r/shittyaskscience',
      '/r/shittyfoodporn',
      '/r/shittyreactiongifs',
      '/r/crappydesign',
      '/r/Shitty_Car_Mods',
      '/r/shittyadvice',
      '/r/shittyrobots',
      '/r/ShittyLifeProTips',
      '/r/shittykickstarters',
      '/r/shittyanimalfacts',
      '/r/shitpost',
      '/r/shittymoviedetails',
      '/r/unexpected',
      '/r/UnexpectedThugLife',
      '/r/misleadingthumbnails',
      '/r/unexpectedjihad',
      '/r/slygifs',
      '/r/blackmagicfuckery',
      '/r/unexpectedhogwarts',
      '/r/UnexpectedMulaney',
      '/r/AbandonedPorn',
      '/r/OddlySatisfying',
      '/r/RoomPorn',
      '/r/nonononoyes',
      '/r/minimalism',
      '/r/CityPorn',
      '/r/penmanshipporn',
      '/r/Cinemagraphs',
      '/r/ImaginaryLandscapes',
      '/r/eyebleach',
      '/r/DesignPorn',
      '/r/perfectloops',
      '/r/perfectfit',
      '/r/humansbeingbros',
      '/r/powerwashingporn',
      '/r/nevertellmetheodds',
      '/r/typography',
      '/r/cozyplaces',
      '/r/breathinginformation',
      '/r/desirepath',
      '/r/tiltshift',
      '/r/mostbeautiful',
      '/r/AmateurRoomPorn',
      '/r/slygifs',
      '/r/raining',
      '/r/AccidentalWesAnderson',
      '/r/unstirredpaint',
      '/r/handwriting',
      '/r/thatpeelingfeeling',
      '/r/gtage',
      '/r/satisfyingasfuck',
      '/r/holdmybeer',
      '/r/holdmyjuicebox',
      '/r/holdmyfries',
      '/r/holdmybeaker',
      '/r/holdmycosmo',
      '/r/holdmycatnip',
      '/r/holdmyredbull',
      '/r/holdmyfeedingtube',
      '/r/fiftyfifty',
      '/r/firstworldproblems',
      '/r/idiotsfightingthings',
      '/r/whatsinthisthing',
      '/r/AskReddit',
      '/r/notinteresting',
      '/r/fifthworldpics',
      '/r/drunkorakid',
      '/r/pussypassdenied',
      '/r/UNBGBBIIVCHIDCTIICBG',
      '/r/Justfuckmyshitup',
      '/r/BestOfStreamingVideo',
      '/r/CatastrophicFailure',
      '/r/evilbuildings',
      '/r/urbanhell',
      '/r/justiceserved',
      '/r/mypeopleneedme',
      '/r/notmyjob',
      '/r/onejob',
      '/r/sweatypalms',
      '/r/therewasanattempt',
      '/r/bitchimabus',
      '/r/greendawn',
      '/r/thingsforants',
      '/r/youseeingthisshit',
      '/r/hmmm',
      '/r/hadtohurt',
      '/r/MandelaEffect',
      '/r/mildlypenis',
      '/r/redditdayof',
      '/r/instantkarma',
      '/r/2healthbars',
      '/r/collapse',
      '/r/slavs_squatting',
      '/r/confusing_perspective',
      '/r/the_pack',
      '/r/unpopularopinion',
      '/r/okbuddyretard',
      '/r/nextfuckinglevel',
      '/r/ooer',
      '/r/happycryingdads',
      '/r/FullScorpion',
      '/r/instantregret',
      '/r/MildlyVandalised',
      '/r/watchpeoplesurvive',
      '/r/tendies',
      '/r/dontputyourdickinthat',
      '/r/whatintarnation',
      '/r/tworedditorsonecup',
      '/r/ExpandDong',
      '/r/wackytictacs',
      '/r/halloween',
      '/r/whatcouldgoright',
      '/r/hmmmgifs',
      '/r/bizarrebuildings',
      '/r/inclusiveor',
      '/r/lostgeneration',
      '/r/kurzgesagt',
      '/r/boop',
      '/r/fightporn',
      '/r/tooktoomuch',
      '/r/humansaremetal',
      '/r/theyknew',
      '/r/fbiopenup',
      '/r/fuckyouinparticular',
      '/r/idiotsnearlydying',
      '/r/AAAAAAAAAAAAAAAAA',
      '/r/chaoticgood',
      '/r/prisonwallet',
      '/r/mindcrack',
      '/r/twitchplayspokemon',
      '/r/battlefield3',
      '/r/punchablefaces',
      '/r/csgobetting',
      '/r/historicalwhatif',
     ]
    numSubs.value = subs.length
    fetchedSubs.value = subs
  }

  function selectRandomSubIndex() {
    const randomIndex = Math.floor(Math.random() * fetchedSubs.value.length)
    return randomIndex
  }

  function ButtonClick() {
    let random_reddit_index = selectRandomSubIndex()
    let new_page = 'https://www.reddit.com' + fetchedSubs.value[random_reddit_index]
    window.location.href = new_page
  }

  onMounted(()  => {
    fetchSubs()
  })

</script>

<template>
<section class="main_grid">
  <h1>Random Reddit Page</h1>
  <p>Click to go to a random sub-reddit!</p>
  <button @click="ButtonClick()">Go!</button>
</section>

</template>

<style>
.main_grid {
  display: grid;
  grid-template-rows: auto 4rem 1fr;
  width: 100%;
  height: 250px;
  justify-content: center;
  text-align: center;
}

h1 {
  font-size: 3rem;
}

p {
  font-size: 1rem;
}

button {
  font-size: 1rem;
  background-color: #ee9311;
  border-radius: 5px;
  border: 0px;
  width: 5rem;
  height: 3rem;
  margin: 0 auto;
  box-shadow: 0px 0px 15px 3px #000000;
  cursor: pointer;
}
</style>
